<template>
  <div
    class="tabview"
    @click="$emit('selected', type)"
    :style="selected ? 'color: rgb(36, 36, 36);' : 'color: rgb(128, 128, 128);'"
  >
    <p>
      {{ title }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'TankingTabView',
  props: {
    type: Number,
    title: String,
    selected: Boolean,
  },
}
</script>

<style scoped>
.tabview {
  flex-grow: 1;
  margin: auto;
}
.tabview p {
  text-align: center;
  /* color: rgb(36, 36, 36); */
  font-size: 14px;
}
</style>
